import { PushpinFilled } from "@ant-design/icons";
import { formatarHoraChat } from "./chatFormat";

export const ChatFixadas = ({ mensagens, onDesafixar, onIrPara }) => {
  if (!mensagens?.length) {
    return null;
  }
  return (
    <div className="chat-fixadas">
      {mensagens.map((mensagem) => (
        <div className="chat-fixada-item" key={mensagem.codigo}>
          <button
            type="button"
            className="chat-fixada-item__texto"
            onClick={() => onIrPara(mensagem.codigo)}
            title="Ir para a mensagem"
          >
            <PushpinFilled />
            <span>{mensagem.conteudo}</span>
            <time>{formatarHoraChat(mensagem.dataCadastro)}</time>
          </button>
          <button
            type="button"
            className="chat-fixada-item__soltar"
            onClick={() => onDesafixar(mensagem)}
            aria-label="Desafixar mensagem"
            title="Desafixar"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};
